"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BAMViewer", {
  enumerable: true,
  get: function get() {
    return _BAM["default"];
  }
});
Object.defineProperty(exports, "BaseAlignment", {
  enumerable: true,
  get: function get() {
    return _BaseAlignment["default"];
  }
});
Object.defineProperty(exports, "BaseSVGAlignment", {
  enumerable: true,
  get: function get() {
    return _BaseSVGAlignment["default"];
  }
});
Object.defineProperty(exports, "SiteAxis", {
  enumerable: true,
  get: function get() {
    return _SiteAxis["default"];
  }
});
Object.defineProperty(exports, "SitePlotAxis", {
  enumerable: true,
  get: function get() {
    return _SitePlotAxis["default"];
  }
});
Object.defineProperty(exports, "SequenceAxis", {
  enumerable: true,
  get: function get() {
    return _SequenceAxis["default"];
  }
});
Object.defineProperty(exports, "fastaParser", {
  enumerable: true,
  get: function get() {
    return _fasta["default"];
  }
});
Object.defineProperty(exports, "computeLabelWidth", {
  enumerable: true,
  get: function get() {
    return _computeLabelWidth["default"];
  }
});
Object.defineProperty(exports, "ScrollBroadcaster", {
  enumerable: true,
  get: function get() {
    return _ScrollBroadcaster["default"];
  }
});
exports.colors = exports["default"] = void 0;

var _Alignment = _interopRequireDefault(require("./Alignment.js"));

var _BAM = _interopRequireDefault(require("./app/BAM.js"));

var _BaseAlignment = _interopRequireDefault(require("./components/BaseAlignment.js"));

var _BaseSVGAlignment = _interopRequireDefault(require("./components/BaseSVGAlignment.js"));

var _SiteAxis = _interopRequireDefault(require("./components/SiteAxis.js"));

var _SitePlotAxis = _interopRequireDefault(require("./components/SitePlotAxis.js"));

var _SequenceAxis = _interopRequireDefault(require("./components/SequenceAxis.js"));

var _fasta = _interopRequireDefault(require("./helpers/fasta"));

var _computeLabelWidth = _interopRequireDefault(require("./helpers/computeLabelWidth"));

var _ScrollBroadcaster = _interopRequireDefault(require("./helpers/ScrollBroadcaster"));

var colors = _interopRequireWildcard(require("./helpers/colors"));

exports.colors = colors;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

//import PreventDefaultPatch from "./prevent_default_patch";
// Conflicts with phylotree branch selection
//PreventDefaultPatch(document);
var _default = _Alignment["default"];
exports["default"] = _default;